import React from 'react';
export function FooterSection() {
  return <footer className="bg-deep-black border-t border-white/10 pt-16 pb-8 px-4" data-id="element-66">
      <div className="max-w-7xl mx-auto flex flex-col items-center text-center" data-id="element-67">
        <h2 className="font-heading text-2xl font-bold text-white tracking-widest mb-2" data-id="element-68">
          EL LECTOR DE MENTES ™
        </h2>
        <p className="text-smoke/60 mb-12" data-id="element-69">
          Sistema completo de lectura no verbal · Pack de 6 Tomos PDF
        </p>

        <div className="flex flex-wrap justify-center gap-6 md:gap-12 text-sm text-smoke/80 mb-12" data-id="element-70">
          <a href="#" className="hover:text-gold transition-colors" data-id="element-71">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-72">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-73">
            Política de Devolución
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-74">
            Contacto
          </a>
        </div>

        <div className="w-full h-px bg-white/5 mb-8" data-id="element-75" />

        <p className="text-smoke/40 text-sm mb-4" data-id="element-76">
          © 2024 El Lector de Mentes. Todos los derechos reservados.
        </p>
        <p className="text-smoke/30 text-xs max-w-3xl mx-auto leading-relaxed" data-id="element-77">
          Disclaimer: Este producto es de carácter educativo. Las técnicas aquí
          descritas son herramientas de autoconocimiento y comunicación
          interpersonal. No reemplaza asesoramiento psicológico profesional.
        </p>
      </div>
    </footer>;
}